import { SVGProps } from 'react';

export const PageNotFound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8836 0C10.0935 0 8.64267 1.45196 8.64267 3.24097H15.1246C15.1246 1.45196 13.6737 0 11.8836 0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.48187 10.8031H2.16058C2.16058 11.9957 3.12855 12.9637 4.32123 12.9637C5.5139 12.9637 6.48187 11.9957 6.48187 10.8031Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8836 12.9637C13.0763 12.9637 14.0443 11.9957 14.0443 10.8031H9.72296C9.72296 11.9957 10.6909 12.9637 11.8836 12.9637Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.446 12.9637C20.6387 12.9637 21.6066 11.9957 21.6066 10.8031H17.2853C17.2853 11.9957 18.2533 12.9637 19.446 12.9637Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9493 6.27676L15.1245 4.32138H8.64259L0.818886 6.27676C0.338142 6.39668 0 6.82881 0 7.32468V8.64267C0 9.23901 0.483985 9.723 1.08032 9.723H22.6868C23.2842 9.723 23.7671 9.23901 23.7671 8.64267V7.32468C23.7671 6.82881 23.4301 6.39668 22.9493 6.27676Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.42812 23.5311L7.53692 24L9.69757 14.2771L7.58877 13.8082L5.42812 23.5311Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0708 14.2771L16.2314 24L18.3402 23.5311L16.1796 13.8082L14.0708 14.2771Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8032 23.7672H12.9639V16.2049H10.8032V23.7672Z"
      fill="currentColor"
    />
  </svg>
);
